import React from 'react'
import { Avatar, Box, Card, Chip, Link, Typography } from '@mui/material'

export const CartColor = ({title, body, chip, linkText}: any) => {
  return (
<>
 <Card variant="outlined" sx={{ borderRadius: 4, p: 4, position: 'relative', borderLeft: '6px solid #1976d2' }}>
      
      {/* Header: Icono, Título y Chip */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>

        
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h5" fontWeight="bold">
              {title}
            </Typography>
            <Chip 
              label={chip?.text} 
              color={chip?.color}
              //variant="soft" 
              size="small"
              sx={{ bgcolor: '#e3f2fd', color: '#1976d2', fontWeight: 'bold' }} 
            />
          </Box>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: '80%' }}>
            {body}
          </Typography>
        </Box>
      </Box>

      {/* Contenedor de la Key */}
    <Box>

    </Box>

      {/* Footer: Links */}
      <Box sx={{ mt: 3, display: 'flex', gap: 3 }}>
        <Link href="#" underline="hover" sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
          {linkText}
        </Link>
        <Link href="#" underline="hover" color="inherit" sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
        </Link>
      </Box>
      
    </Card>
</>
  )
}
